module.exports = __webpack_public_path__ + "img/enTxt5.ff178f6d.png";